export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chaîne de"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["à"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["caractères"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valeur non valide"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Champ obligatoire"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vérifiez les champs"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SVG, PNG ou JPG"])}
}